import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { PlayerProvider } from "./context/PlayerContext";
import { CartProvider } from "./context/CartContext";
import { CartDrawer } from "./components/CartDrawer";
import { ThemeInjector } from "./components/ThemeInjector";
import AudioPlayer from "./components/AudioPlayer";
import { UnlockFullSongModal } from "./components/UnlockFullSongModal";
import { API } from "./config/api";
import Home from "./pages/Home";
import Tracks from "./pages/Tracks";
import Videos from "./pages/Videos";
import FreeMediaPage from "./pages/FreeMediaPage";
import BeatsPage from "./pages/BeatsPage";
import Links from "./pages/Links";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Success from "./pages/Success";
import ArtistPage from "./pages/ArtistPage";
import ArtistPortal from "./pages/ArtistPortal";
import ApplyPage from "./pages/ApplyPage";
import Store from "./pages/Store";
import MyPurchases from "./pages/MyPurchases";
import ImageEnhance from "./pages/ImageEnhance";

function App() {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/site-settings`).then(r => setSiteSettings(r.data)).catch(() => {});
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
      <PlayerProvider>
        <div className="App">
          <ThemeInjector settings={siteSettings} />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/tracks" element={<Tracks />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/free-media" element={<FreeMediaPage />} />
              <Route path="/beats" element={<BeatsPage />} />
              <Route path="/links" element={<Links />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/success" element={<Success />} />
              <Route path="/artist/:slug" element={<ArtistPage />} />
              <Route path="/apply" element={<ApplyPage />} />
              <Route path="/featured" element={<ArtistPortal />} />
              <Route path="/store" element={<Store />} />
              <Route path="/my-purchases" element={<MyPurchases />} />
              <Route path="/enhance" element={<ImageEnhance />} />
            </Routes>
          </BrowserRouter>
          <AudioPlayer />
          <UnlockFullSongModal />
          <CartDrawer />
          <Toaster position="top-right" />
        </div>
      </PlayerProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
